export * from '@primeuix/themes/material/breadcrumb';
export { default } from '@primeuix/themes/material/breadcrumb';
